import { useHistory } from 'hooks/generic/useHistory';

export const useHandleCloseModalOrDrawer = () => {
  const { goBack } = useHistory();

  return goBack;
};
